const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3573.9189,
    y1: 4029.532,
    x2: 1127.3884,
    y2: 991.0947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2910.684,2824.458c-56.734,58.788-110.415,96.7-152.828,126.653 c-498.552,352.092-1088.471,249.459-1213.845,224.395c-185.139-37.011-543.008-108.554-801.741-408.034 c-391.441-453.089-330.488-1166.918-26.86-1638.127c55.538-86.192,348.908-564.578,945.181-641.296 c360.858-46.429,781.502,47.213,1086.122,298.41C3386.135,1313.744,3340.615,2378.956,2910.684,2824.458z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M996.654,1243.762c0.257-13.323,11.452-24.044,25.173-24.044h832.258 c13.906,0,28.676,11.051,28.676,24.556v1886.347c0,10.08-5.88,19.746-13.229,26.865c-7.35,7.118-18.188,11.103-28.568,11.075 l-841.374-2.23c-10.47-0.028-20.707-4.136-28.031-11.403c-7.324-7.267-11.447-17.11-11.25-27.277L996.654,1243.762z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.52
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1474.608,1353.4 1746.859,1352.485 1746.757,1319.403 1474.811,1320.238  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1473.862,1475.252 1747.232,1474.041 1747.13,1440.687 1474.067,1441.816  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1473.109,1598.11 1747.608,1596.598 1747.505,1562.969 1473.316,1564.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1472.35,1721.991 1747.988,1720.172 1747.883,1686.264 1472.558,1687.999  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1471.585,1846.902 1748.37,1844.772 1748.265,1810.582 1471.795,1812.626  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1470.036,2099.872 1749.145,2097.104 1749.038,2062.339 1470.249,2065.018  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1467.662,2487.403 1750.33,2483.637 1750.221,2447.982 1467.881,2451.654  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1470.814,1972.858 1748.755,1970.411 1748.65,1935.935 1471.025,1938.295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1469.251,2227.961 1749.536,2224.865 1749.428,2189.806 1469.466,2192.813  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1468.46,2357.133 1749.932,2353.705 1749.823,2318.349 1468.677,2321.686  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1466.857,2618.788 1750.733,2614.678 1750.622,2578.717 1467.078,2582.732  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1466.045,2751.3 1751.139,2746.841 1751.027,2710.572 1466.269,2714.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1465.227,2884.957 1751.547,2880.143 1751.436,2843.561 1465.451,2848.277  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1464.4,3019.768 1751.96,3014.593 1751.847,2977.695 1464.628,2982.771  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1117.667,1354.6 1391.625,1353.679 1391.922,1320.493 1118.271,1321.333  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1115.444,1476.84 1390.537,1475.621 1390.835,1442.161 1116.054,1443.298  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1113.204,1600.094 1389.439,1598.572 1389.74,1564.834 1113.818,1566.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1110.945,1724.376 1388.333,1722.546 1388.637,1688.528 1111.565,1690.274  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1108.667,1849.695 1387.216,1847.551 1387.523,1813.25 1109.292,1815.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1104.052,2103.502 1384.956,2100.716 1385.268,2065.835 1104.688,2068.532  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1096.984,2492.342 1381.494,2488.552 1381.813,2452.774 1097.636,2456.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1106.369,1976.066 1386.091,1973.604 1386.4,1939.014 1106.999,1941.389  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1101.716,2232.02 1383.812,2228.904 1384.126,2193.729 1102.357,2196.753  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1099.36,2361.627 1382.658,2358.177 1382.975,2322.702 1100.007,2326.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1094.587,2624.177 1380.32,2620.041 1380.642,2583.957 1095.245,2587.998  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1092.17,2757.147 1379.135,2752.659 1379.461,2716.264 1092.833,2720.656  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1089.731,2891.271 1377.942,2886.424 1378.269,2849.715 1090.4,2854.463  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1087.272,3026.555 1376.737,3021.346 1377.068,2984.319 1087.947,2989.427  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M519.065,1764.072c0.365-15.408,16.186-28.087,35.579-28.087h733.014 c19.653,0,38.954,13.341,38.954,28.958v1395.908c0,7.513-5.447,14.718-12.141,20.023c-6.695,5.305-16.614,8.275-26.068,8.255 l-766.406-1.663c-9.537-0.021-18.874-3.082-25.544-8.499c-6.67-5.417-10.431-12.903-10.253-20.48L519.065,1764.072z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158737914120299194310000015175482558791303565_",
    gradientUnits: "userSpaceOnUse",
    x1: 1058.8914,
    y1: 1857.8364,
    x2: 1269.3678,
    y2: 1857.8364
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000158737914120299194310000015175482558791303565_)"
    },
    points: "1058.891,1900.476  1267.711,1900.253 1269.368,1815.197 1060.345,1815.197  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114061160107477707260000004268933470618389915_",
    gradientUnits: "userSpaceOnUse",
    x1: 824.8279,
    y1: 1857.8152,
    x2: 1034.8676,
    y2: 1857.8152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000114061160107477707260000004268933470618389915_)"
    },
    points: "824.828,1900.434  1033.438,1900.21 1034.868,1815.197 826.055,1815.197  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061436769828312102790000006966796643392803209_",
    gradientUnits: "userSpaceOnUse",
    x1: 591,
    y1: 1857.7938,
    x2: 800.6026,
    y2: 1857.7938
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000061436769828312102790000006966796643392803209_)"
    },
    points: "591,1900.391  799.401,1900.168 800.603,1815.197 592.001,1815.197  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047040147058526811790000018193058190219421115_",
    gradientUnits: "userSpaceOnUse",
    x1: 1056.2817,
    y1: 2010.9712,
    x2: 1266.3884,
    y2: 2010.9712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047040147058526811790000018193058190219421115_)"
    },
    points: "1056.282,2053.15  1264.738,2053.256 1266.388,1968.755 1057.731,1968.686  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096050798121977679460000018237269733266168233_",
    gradientUnits: "userSpaceOnUse",
    x1: 822.6263,
    y1: 2010.8732,
    x2: 1032.2979,
    y2: 2010.8732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000096050798121977679460000018237269733266168233_)"
    },
    points: "822.626,2053.031  1030.873,2053.137 1032.298,1968.678 823.849,1968.609  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167373987994949456280000012847712104613948347_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.2053,
    y1: 2010.7756,
    x2: 798.4407,
    y2: 2010.7756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000167373987994949456280000012847712104613948347_)"
    },
    points: "589.205,2052.913  797.243,2053.018 798.441,1968.601 590.202,1968.533  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093877839570842484400000013306718180218998154_",
    gradientUnits: "userSpaceOnUse",
    x1: 1053.6813,
    y1: 2162.7764,
    x2: 1263.4193,
    y2: 2162.7764
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000093877839570842484400000013306718180218998154_)"
    },
    points: "1053.681,2204.775  1261.774,2204.949 1263.419,2120.74 1055.125,2120.604  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077296335539839295150000015742998153746574772_",
    gradientUnits: "userSpaceOnUse",
    x1: 820.432,
    y1: 2162.6023,
    x2: 1029.736,
    y2: 2162.6023
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000077296335539839295150000015742998153746574772_)"
    },
    points: "820.432,2204.58  1028.317,2204.753 1029.736,2120.588 821.65,2120.451  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116941358463160768300000018076633411430253701_",
    gradientUnits: "userSpaceOnUse",
    x1: 587.4167,
    y1: 2162.429,
    x2: 796.2862,
    y2: 2162.429
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000116941358463160768300000018076633411430253701_)"
    },
    points: "587.417,2204.385  795.093,2204.559 796.286,2120.435 588.41,2120.299  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174570222148100785320000016251592564690377636_",
    gradientUnits: "userSpaceOnUse",
    x1: 1051.0896,
    y1: 2314.0552,
    x2: 1260.4606,
    y2: 2314.0552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000174570222148100785320000016251592564690377636_)"
    },
    points: "1051.09,2355.875  1258.822,2356.116 1260.461,2272.198 1052.528,2271.995  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136381443824599628090000017587905722546993810_",
    gradientUnits: "userSpaceOnUse",
    x1: 818.2451,
    y1: 2313.8059,
    x2: 1027.1837,
    y2: 2313.8059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000136381443824599628090000017587905722546993810_)"
    },
    points: "818.245,2355.605  1025.77,2355.845 1027.184,2271.97 819.459,2271.767  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075863032574571279250000015807840234447830205_",
    gradientUnits: "userSpaceOnUse",
    x1: 585.6337,
    y1: 2313.5574,
    x2: 794.1396,
    y2: 2313.5574
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000075863032574571279250000015807840234447830205_)"
    },
    points: "585.634,2355.335  792.95,2355.576 794.14,2271.742 586.623,2271.539  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016046649639400605590000010872154751345654942_",
    gradientUnits: "userSpaceOnUse",
    x1: 1048.5074,
    y1: 2464.8113,
    x2: 1257.5118,
    y2: 2464.8113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000016046649639400605590000010872154751345654942_)"
    },
    points: "1048.507,2506.452  1255.879,2506.76 1257.512,2423.133 1049.941,2422.862  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124867892354133232050000005283455096992139447_",
    gradientUnits: "userSpaceOnUse",
    x1: 816.0661,
    y1: 2464.4871,
    x2: 1024.6396,
    y2: 2464.4871
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000124867892354133232050000005283455096992139447_)"
    },
    points: "816.066,2506.108  1023.231,2506.415 1024.64,2422.83 817.276,2422.559  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041979484654584066920000005341747824571629981_",
    gradientUnits: "userSpaceOnUse",
    x1: 583.8569,
    y1: 2464.1636,
    x2: 792,
    y2: 2464.1636
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000041979484654584066920000005341747824571629981_)"
    },
    points: "583.857,2505.764  790.815,2506.07 792,2422.526 584.843,2422.257  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057843602557453898400000012034921832273539460_",
    gradientUnits: "userSpaceOnUse",
    x1: 1045.9338,
    y1: 2615.0466,
    x2: 1254.5739,
    y2: 2615.0466
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000057843602557453898400000012034921832273539460_)"
    },
    points: "1045.934,2656.511  1252.946,2656.885 1254.574,2573.546 1047.362,2573.209  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070103822294003303930000016921703664477562022_",
    gradientUnits: "userSpaceOnUse",
    x1: 813.8941,
    y1: 2614.6479,
    x2: 1022.1053,
    y2: 2614.6479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000070103822294003303930000016921703664477562022_)"
    },
    points: "813.894,2656.092  1020.701,2656.465 1022.105,2573.168 815.1,2572.831  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073002760893215473840000007368479592613828517_",
    gradientUnits: "userSpaceOnUse",
    x1: 582.0867,
    y1: 2614.2505,
    x2: 789.8682,
    y2: 2614.2505
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000073002760893215473840000007368479592613828517_)"
    },
    points: "582.087,2655.673  788.687,2656.046 789.868,2572.79 583.07,2572.454  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013893143057483521250000012279648964926336649_",
    gradientUnits: "userSpaceOnUse",
    x1: 1043.3684,
    y1: 2764.7644,
    x2: 1251.6458,
    y2: 2764.7644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000013893143057483521250000012279648964926336649_)"
    },
    points: "1043.368,2806.052  1250.023,2806.491 1251.646,2723.44 1044.792,2723.037  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121985809302913424850000001656967983672458383_",
    gradientUnits: "userSpaceOnUse",
    x1: 811.7304,
    y1: 2764.292,
    x2: 1019.5788,
    y2: 2764.292
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000121985809302913424850000001656967983672458383_)"
    },
    points: "811.73,2805.56  1018.18,2805.999 1019.579,2722.988 812.931,2722.585  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111899130444610335570000001103899588741152181_",
    gradientUnits: "userSpaceOnUse",
    x1: 580.3221,
    y1: 2763.8201,
    x2: 787.7435,
    y2: 2763.8201
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000111899130444610335570000001103899588741152181_)"
    },
    points: "580.322,2805.068  786.566,2805.506 787.744,2722.536 581.302,2722.134  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029740344582291789120000001230094567711971758_",
    gradientUnits: "userSpaceOnUse",
    x1: 1040.8126,
    y1: 2913.967,
    x2: 1248.7279,
    y2: 2913.967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000029740344582291789120000001230094567711971758_)"
    },
    points: "1040.813,2955.079  1247.111,2955.584 1248.728,2872.818 1042.232,2872.35  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078024380001805519990000017110607063438199697_",
    gradientUnits: "userSpaceOnUse",
    x1: 809.5737,
    y1: 2913.4211,
    x2: 1017.062,
    y2: 2913.4211
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000078024380001805519990000017110607063438199697_)"
    },
    points: "809.574,2954.513  1015.667,2955.018 1017.062,2872.292 810.771,2871.825  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065039343399223276590000012080393196340225681_",
    gradientUnits: "userSpaceOnUse",
    x1: 578.5637,
    y1: 2912.8762,
    x2: 785.6253,
    y2: 2912.8762
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065039343399223276590000012080393196340225681_)"
    },
    points: "578.564,2953.949  784.453,2954.452 785.625,2871.768 579.54,2871.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155111782756984771900000006301642608989550258_",
    gradientUnits: "userSpaceOnUse",
    x1: 1038.2651,
    y1: 3062.6575,
    x2: 1245.8195,
    y2: 3062.6575
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000155111782756984771900000006301642608989550258_)"
    },
    points: "1038.265,3103.595  1244.208,3104.165 1245.819,3021.683 1039.679,3021.15  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040543193826436701980000006830890455035639711_",
    gradientUnits: "userSpaceOnUse",
    x1: 807.4241,
    y1: 3062.0386,
    x2: 1014.5535,
    y2: 3062.0386
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000040543193826436701980000006830890455035639711_)"
    },
    points: "807.424,3102.957  1013.163,3103.526 1014.554,3021.084 808.617,3020.551  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130643679235838206250000015099477643329315728_",
    gradientUnits: "userSpaceOnUse",
    x1: 576.8118,
    y1: 3061.4207,
    x2: 783.5159,
    y2: 3061.4207
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000130643679235838206250000015099477643329315728_)"
    },
    points: "576.812,3102.319  782.346,3102.887 783.516,3020.486 577.784,3019.954  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2432.45,1797.407c0.365-15.408,16.186-28.087,35.579-28.087h733.014 c19.653,0,38.954,13.341,38.954,28.958v1395.907c0,7.513-5.447,14.718-12.14,20.024c-6.695,5.305-16.614,8.275-26.068,8.255 l-766.406-1.663c-9.537-0.021-18.874-3.082-25.544-8.499s-10.431-12.903-10.252-20.48L2432.45,1797.407z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2972.276,1933.81 3181.096,1933.588 3182.752,1848.531 2973.73,1848.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2738.212,1933.768 2946.823,1933.545 2948.252,1848.531 2739.439,1848.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2504.385,1933.725 2712.785,1933.502 2713.987,1848.531 2505.385,1848.531  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2969.666,2086.485 3178.122,2086.59 3179.773,2002.089 2971.115,2002.021  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2736.011,2086.365 2944.258,2086.471 2945.683,2002.012 2737.233,2001.943  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2502.59,2086.247 2710.627,2086.352 2711.825,2001.936 2503.586,2001.867  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2967.066,2238.109 3175.159,2238.283 3176.804,2154.074 2968.509,2153.938  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2733.817,2237.915 2941.702,2238.087 2943.121,2153.922 2735.035,2153.786  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2500.801,2237.72 2708.478,2237.894 2709.671,2153.769 2501.794,2153.633  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2964.474,2389.209 3172.206,2389.45 3173.845,2305.532 2965.913,2305.329  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2731.63,2388.939 2939.154,2389.179 2940.568,2305.304 2732.844,2305.101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2499.018,2388.67 2706.335,2388.91 2707.524,2305.076 2500.008,2304.873  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2961.892,2539.787 3169.263,2540.094 3170.896,2456.468 2963.326,2456.197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2729.451,2539.442 2936.615,2539.749 2938.024,2456.164 2730.66,2455.893  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2497.241,2539.098 2704.199,2539.405 2705.385,2455.861 2498.228,2455.591  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2959.318,2689.845 3166.331,2690.219 3167.958,2606.88 2960.747,2606.543  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2727.279,2689.426 2934.086,2689.799 2935.49,2606.502 2728.484,2606.165  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2495.471,2689.007 2702.071,2689.381 2703.253,2606.125 2496.454,2605.789  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2956.753,2839.386 3163.407,2839.826 3165.03,2756.774 2958.177,2756.372  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2725.115,2838.894 2931.564,2839.333 2932.963,2756.322 2726.316,2755.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2493.707,2838.402 2699.95,2838.841 2701.128,2755.871 2494.687,2755.469  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2954.197,2988.414 3160.496,2988.919 3162.113,2906.153 2955.616,2905.684  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2722.958,2987.848 2929.052,2988.352 2930.447,2905.627 2724.155,2905.159  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2491.948,2987.283 2697.837,2987.786 2699.01,2905.102 2492.925,2904.635  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2951.65,3136.93 3157.593,3137.499 3159.204,3055.017 2953.064,3054.484  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2720.809,3136.291 2926.548,3136.86 2927.938,3054.418 2722.002,3053.885  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2490.196,3135.654 2695.731,3136.222 2696.9,3053.821 2491.169,3053.288  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1703.744,2177.14c-59.822-187.828-175.569-337.517-312.674-425.514 c-122.564-78.665-210.866-201.177-243.559-342.693c-3.437-14.874-7.521-29.792-12.271-44.704 c-71.949-225.895-269.286-364.742-440.766-310.125c-171.482,54.616-252.17,282.016-180.221,507.909 c14.71,46.191,34.668,88.731,58.576,126.718c76.302,121.23,106.16,266.633,78.086,407.268 c-25.093,125.679-18.284,267.188,26.567,408.007c66.892,210.022,203.704,372.371,362.117,454.102 c59.919,30.914,113.951,72.485,158.691,122.719c74.354,83.476,179.139,122.714,275.414,92.052 c103.856-33.08,168.741-138.248,173.41-260.955c2.642-69.436,18.969-137.495,45.581-201.838 C1755.516,2558.19,1764.23,2367.041,1703.744,2177.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M831.058,1275.286c69.952,142.157,135.259,286.453,199.049,431.429 c15.963,36.237,31.341,72.727,46.835,109.166l23.233,54.664l22.774,54.859c15.039,36.631,30.589,73.053,45.212,109.856 l43.878,110.403c28.309,73.975,57.246,147.706,84.171,222.21c13.514,37.228,27.757,74.187,40.511,111.695l38.78,112.317 c50.183,150.271,96.596,301.882,135.214,455.554l-6.635,1.741l-33.29-113.869l-8.258-28.475l-8.971-28.269l-18.049-56.497 l-17.939-56.52c-5.945-18.85-12.594-37.48-18.856-56.23c-12.778-37.417-25.255-74.931-38.274-112.261 c-53.051-148.996-108.089-297.285-166.193-444.415c-29.618-73.343-58.6-146.933-88.731-220.074l-22.446-54.915l-22.909-54.728 c-15.25-36.495-30.502-72.989-46.123-109.328c-30.618-72.946-61.764-145.677-93.504-218.151 c-31.36-72.64-63.414-145.001-95.678-217.231L831.058,1275.286z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2204.203,1803.793c-27.958-205.127-120.369-380.942-245.846-496.816 c-112.17-103.584-181.179-246.313-189.489-398.619c-0.874-16.009-2.408-32.181-4.627-48.467 c-33.624-246.701-212.039-426.09-398.502-400.676c-186.464,25.413-310.364,246.006-276.74,492.707 c6.875,50.446,19.81,98.065,37.631,141.691c56.873,139.228,61.568,295.042,7.426,435.423 c-48.383,125.453-66.741,273.062-45.781,426.851c31.262,229.367,143.107,422.096,291.66,535.349 c56.19,42.838,104.402,95.63,141.493,155.7c61.637,99.824,162.557,159.404,267.242,145.136 c112.932-15.392,198.635-112.416,225.446-238.494c15.172-71.346,44.196-138.785,83.149-200.518 C2189.223,2207.331,2232.47,2011.188,2204.203,1803.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M1466.802,712.759c46.581,159.724,87.992,320.816,127.721,482.34 c9.95,40.376,19.249,80.908,28.679,121.409l14.135,60.754l13.627,60.872c8.928,40.617,18.417,81.111,26.884,121.831 l25.413,122.151c15.9,81.649,32.494,163.16,46.875,245.105c7.248,40.958,15.294,81.769,21.711,122.878l19.816,123.208 c24.759,164.535,45.395,329.769,57.63,495.724l-7.147,0.599l-13.882-123.819l-3.403-30.951l-4.175-30.866l-8.466-61.711 l-8.349-61.715c-2.745-20.574-6.256-41.051-9.345-61.58c-6.455-41.02-12.584-82.085-19.304-123.059 c-27.943-163.733-58.06-327.096-91.543-489.817c-17.364-81.232-34.03-162.606-51.959-243.723l-13.279-60.871l-13.79-60.761 c-9.169-40.513-18.339-81.027-27.918-121.448c-18.466-81.002-37.514-161.88-57.221-242.598 c-19.283-80.821-39.334-161.481-59.626-242.041L1466.802,712.759z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011025354068592873840000005019076613414790294_",
    gradientUnits: "userSpaceOnUse",
    x1: 2741.292,
    y1: -790.1846,
    x2: 2137.1833,
    y2: 2733.7744
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011025354068592873840000005019076613414790294_)"
    },
    d: "M3061.221,3213.664H1433.566 c-12.721,0-23.034-10.313-23.034-23.034V991.137c0-12.721,10.313-23.034,23.034-23.034h1627.656 c12.721,0,23.034,10.313,23.034,23.034V3190.63C3084.255,3203.351,3073.942,3213.664,3061.221,3213.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2799.324,2917.863H1691.895c-41.979,0-76.009-34.031-76.009-76.009V1381.473 c0-41.979,34.03-76.009,76.009-76.009h1107.429c41.979,0,76.009,34.03,76.009,76.009v1460.381 C2875.333,2883.832,2841.302,2917.863,2799.324,2917.863z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080892473153598892750000001438551094221075871_",
    gradientUnits: "userSpaceOnUse",
    x1: 1711.9962,
    y1: 2121.8967,
    x2: 2780.2222,
    y2: 2121.8967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080892473153598892750000001438551094221075871_)"
    },
    d: "M2757.42,2805.691H1734.798 c-12.593,0-22.802-10.209-22.802-22.802V1460.904c0-12.593,10.209-22.802,22.802-22.802H2757.42 c12.593,0,22.802,10.209,22.802,22.802v1321.985C2780.222,2795.483,2770.013,2805.691,2757.42,2805.691z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000090292717589653727340000013743384154909619626_",
    gradientUnits: "userSpaceOnUse",
    x1: 2329.2961,
    y1: 944.2405,
    x2: 2654.2888,
    y2: 194.2579
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000090292717589653727340000013743384154909619626_)"
    },
    cx: 2244.341,
    cy: 1140.29,
    r: 50.071
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006666813471469190200000003008808555449774756_",
    gradientUnits: "userSpaceOnUse",
    x1: 2358.8447,
    y1: 1430.0939,
    x2: 1627.453,
    y2: 6499.395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006666813471469190200000003008808555449774756_)"
    },
    d: "M2567.821,1948.6l-644.171,10.71 c-49.027,0.815-88.916,38.939-88.916,85.15v405.677c0,46.211,39.889,82.07,88.916,80.101l644.171-25.867 c46.274-1.858,83.653-39.563,83.653-84.225v-392.071C2651.473,1983.414,2614.094,1947.831,2567.821,1948.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060752865740780560200000002525390833027797178_",
    gradientUnits: "userSpaceOnUse",
    x1: 2339.6602,
    y1: 1427.326,
    x2: 1608.2683,
    y2: 6496.6289
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060752865740780560200000002525390833027797178_)"
    },
    d: "M2600.426,1875.23 c-19.51,0.291-35.35-14.767-35.35-33.632v-88.788c0-89.073-75.344-161.321-168.614-161.051l-209.853,0.606 c-95.672,0.276-174.07,74.66-174.07,165.812v90.861c0,19.306-16.611,35.204-37.133,35.51 c-20.556,0.306-37.246-15.144-37.246-34.509v-91.14c0-130.1,112.087-235.946,248.45-235.946h209.853 c132.496,0,239.21,102.806,239.21,229.171v88.523C2635.671,1859.456,2619.904,1874.939,2600.426,1875.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013899319935996365330000005773212780161092029_",
    gradientUnits: "userSpaceOnUse",
    x1: 2381.4185,
    y1: 2006.6177,
    x2: 3453.6072,
    y2: -125.1459
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013899319935996365330000005773212780161092029_)"
    },
    d: "M2349.955,2173.428 c0-45.082-39.355-80.478-87.201-77.227c-42.309,2.875-77.296,36.757-79.581,77.212c-1.773,31.392,15.479,58.528,41.704,72.252 c11.155,5.838,16.696,18.14,14.527,30.31l-18.394,103.213c-2.342,13.144,8.224,24.692,22.125,24.194l47.268-1.693 c13.83-0.496,24.321-12.75,21.997-25.68l-18.381-102.255c-2.192-12.196,4.148-24.313,15.333-31 C2333.676,2228.212,2349.955,2202.422,2349.955,2173.428z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104679358505441559700000011268350591331778196_",
    gradientUnits: "userSpaceOnUse",
    x1: -1483.0153,
    y1: 3175.3572,
    x2: -1364.4141,
    y2: 3175.3572,
    gradientTransform: "matrix(1 0 0 1 2420.5969 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104679358505441559700000011268350591331778196_)"
    },
    d: "M1056.181,3217.587 c0.014-0.883-0.045-1.778-0.272-2.679c-13.358-52.959-79.658-85.944-79.658-85.944l-26.272,2.059 c-15.105,46.677-13.164,75.304-10.738,88.055c0.067,0.358,0.176,0.698,0.271,1.043 C961.184,3222.058,1005.79,3223.322,1056.181,3217.587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M939.512,3220.121c1.17,4.259,4.314,7.574,8.337,8.42c30.829,6.483,79.828,1.266,100.401-1.424 c4.539-0.593,7.857-4.791,7.932-9.53C1005.79,3223.322,961.184,3222.058,939.512,3220.121z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160181152692228729860000007279685044347492263_",
    gradientUnits: "userSpaceOnUse",
    x1: -1450.0334,
    y1: 3040.3352,
    x2: -1472.6882,
    y2: 3238.0508,
    gradientTransform: "matrix(1 0 0 1 2420.5969 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160181152692228729860000007279685044347492263_)"
    },
    d: "M939.416,3091.892l11.127,53.565 c0.815,3.925,3.831,6.864,7.484,7.207c4.471,0.42,10.837,0.666,17.239-0.274c5.74-0.843,9.738-6.676,8.72-12.936l-7.734-47.562 H939.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1169.962,3219.443c-29.016-0.812-44.023-4.229-51.782-7.4c-0.018,2.885-0.002,5.821,0.092,8.863 c0.1,3.249,2.506,5.844,5.467,5.826l159.314-1.029c5.084-0.033,8.055-5.929,5.852-10.592 C1268.016,3216.837,1214.815,3220.698,1169.962,3219.443z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085250484722769570940000014284270196427745963_",
    gradientUnits: "userSpaceOnUse",
    x1: -1302.4172,
    y1: 3178.3716,
    x2: -1131.6923,
    y2: 3178.3716,
    gradientTransform: "matrix(1 0 0 1 2420.5969 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085250484722769570940000014284270196427745963_)"
    },
    d: "M1288.905,3215.111 c-0.192-0.405-0.357-0.819-0.631-1.201c-14.07-19.659-49.904-58.806-120.714-75.785l-33.969-1.072 c0,0-15.126,26.29-15.412,74.99c7.759,3.171,22.766,6.588,51.782,7.4C1214.815,3220.698,1268.016,3216.837,1288.905,3215.111z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166659633736064152530000000504467825716339349_",
    gradientUnits: "userSpaceOnUse",
    x1: -1158.2068,
    y1: 2928.4578,
    x2: -1180.8619,
    y2: 3126.1768,
    gradientTransform: "matrix(0.998 -0.0629 0.0629 0.998 2123.7034 65.7657)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166659633736064152530000000504467825716339349_)"
    },
    d: "M1125.78,3087.152 c0.536,2.503,7.604,40.618,10.342,55.396c0.651,3.511,3.387,6.088,6.642,6.27c5.816,0.326,15.197,0.365,23.265-1.826 c4.352-1.182,7.276-5.619,6.966-10.543l-3.801-60.288L1125.78,3087.152z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181778269755597683110000004400962446514022837_",
    gradientUnits: "userSpaceOnUse",
    x1: -1281.6914,
    y1: 3226.8584,
    x2: -1047.1964,
    y2: 2108.7139,
    gradientTransform: "matrix(-1 0 0 1 -160.9626 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181778269755597683110000004400962446514022837_)"
    },
    d: "M1100.039,2383.406 c0,0,46.729,321.096,80.451,703.196c0.628,7.117-5.043,13.31-12.033,14.782c-10.302,2.17-25.445,4.746-37.981,4.394 c-6.692-0.187-12.286-5.15-13.412-11.75c-11.488-67.37-93.463-428.938-114.978-508.516c0,0-24.714,338.026-16.814,513.397 c0.197,4.36-2.996,8.144-7.332,8.644c-6.578,0.76-17.1,1.338-30.492-0.085c-5.083-0.54-9.184-4.382-9.911-9.443 c-8.183-57.017-55.282-396.404-53.279-640.886c0.113-13.787,16.176-127.065,16.176-127.065L1100.039,2383.406z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065074924465405343840000003825223004430990729_",
    gradientUnits: "userSpaceOnUse",
    x1: 1360.2175,
    y1: 1699.0657,
    x2: 842.0858,
    y2: 2270.6819
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065074924465405343840000003825223004430990729_)"
    },
    d: "M1118.147,1843.429l6.256,168.024 c17.77,6.115,34.688,10.871,50.797,14.424c10.077-32.442,32.265-72.26,50.435-101.865 C1158.879,1900.414,1118.147,1843.429,1118.147,1843.429z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060015437840556854310000013798838091550194082_",
    gradientUnits: "userSpaceOnUse",
    x1: 1259.4879,
    y1: 1730.8054,
    x2: 504.2102,
    y2: 3117.0728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060015437840556854310000013798838091550194082_)"
    },
    d: "M893.411,2401.913 c-4.805-1.707-8.154-6.063-8.677-11.135c-6.214-60.287-36.301-434.09,153.647-587.857c0,0,10.893-28.501,100.43,41.557 c89.537,70.057,41.599,143.49,20.163,244.774c-25.94,122.562-71.453,222.745-51.316,298.167c1.39,5.205-1.347,10.67-6.402,12.533 C1031.704,2425.588,962.419,2426.436,893.411,2401.913z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063621474370039548220000009802735266312299677_",
    gradientUnits: "userSpaceOnUse",
    x1: -1359.6549,
    y1: 1887.9598,
    x2: -1307.0386,
    y2: 1744.2769,
    gradientTransform: "matrix(1 0 0 1 2420.5969 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063621474370039548220000009802735266312299677_)"
    },
    d: "M1112.475,1690.922 c-0.06,5.319-75.908,113.052-75.908,113.052s13.614,26.813,78.608,48.582l56.103-115.35L1112.475,1690.922z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026141767908063323170000001755745509891849891_",
    gradientUnits: "userSpaceOnUse",
    x1: 1106.4756,
    y1: 1424.8339,
    x2: 1082.0304,
    y2: 1611.5056
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026141767908063323170000001755745509891849891_)"
    },
    d: "M1074.9,2059.561 c-0.474,0-0.955-0.135-1.376-0.423c-60.592-40.938-89.096-107.016-89.378-107.68c-0.529-1.256,0.055-2.699,1.306-3.228 c1.256-0.534,2.697,0.048,3.231,1.304c0.275,0.65,28.249,65.423,87.598,105.524c1.128,0.76,1.424,2.29,0.661,3.421 C1076.469,2059.181,1075.691,2059.561,1074.9,2059.561z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054957906111771084590000013933783361653786264_",
    gradientUnits: "userSpaceOnUse",
    x1: 1149.2323,
    y1: 1430.4329,
    x2: 1124.7871,
    y2: 1617.1042
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054957906111771084590000013933783361653786264_)"
    },
    d: "M1165.154,1967.975 c-0.808,0-1.602-0.4-2.073-1.131c-0.183-0.283-18.694-29.098-53.951-92.23c-10.842-19.413-25.091-31.706-42.35-36.537 c-28.583-7.986-56.13,7.338-56.402,7.491c-1.186,0.655-2.685,0.26-3.358-0.923c-0.671-1.183-0.26-2.685,0.923-3.358 c1.188-0.673,29.522-16.527,60.118-7.963c18.591,5.186,33.857,18.269,45.37,38.884c35.168,62.974,53.609,91.687,53.792,91.971 c0.737,1.14,0.407,2.665-0.736,3.402C1166.072,1967.849,1165.611,1967.975,1165.154,1967.975z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135684506876898603900000003860598953956778163_",
    gradientUnits: "userSpaceOnUse",
    x1: -1230.3292,
    y1: 1672.4312,
    x2: -1543.828,
    y2: 1922.1201,
    gradientTransform: "matrix(1 0 0 1 2420.5969 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135684506876898603900000003860598953956778163_)"
    },
    d: "M1172.192,1629.189 c0,0,26.988,61.997,28.801,94.537c1.812,32.54,8.824,53.654-28.801,60.207c-37.625,6.553-69.32-12.191-86.491-44.604 c0,0-26.904-49.945-20.869-70.4C1070.867,1648.474,1172.192,1629.189,1172.192,1629.189z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142877302974653823500000001045476432883990186_",
    gradientUnits: "userSpaceOnUse",
    x1: -1351.3553,
    y1: 1590.2894,
    x2: -1207.6652,
    y2: 1775.2904,
    gradientTransform: "matrix(1 0 0 1 2420.5969 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142877302974653823500000001045476432883990186_)"
    },
    d: "M1098.558,1716.024l2.142-0.944 c2.726-1.202,3.894-4.448,2.524-7.094c-5.305-10.251-15.649-33.743-2.287-39.223c17.22-7.062,85.43-20.972,100.147-45.175 c14.144-23.261,1.612-53.288-17.222-61.828c-1.261-0.572-2.746-0.118-3.393,1.106l-1.569,2.97 c-1.075,2.033-4.078,1.725-4.717-0.484l0,0c-0.614-2.121-3.434-2.531-4.604-0.66c-4.524,7.241-16.737,18.981-49.397,25.008 c-46.417,8.567-77.105,27.351-77.869,59.426c-0.048,2.037-2.216,3.17-3.957,2.109c-3.427-2.089-8.911-3.069-16.241,3.095 c-12.748,10.718-7.531,38.523,20.414,61.395c1.328,1.087,1.317,3.159-0.121,4.095c-5.066,3.297-12.618,11.144,6.95,21.605 c20.24,10.82,35.354,9.932,41.175,8.972c1.448-0.239,2.381-1.641,2.065-3.074l-6.211-28.19 c-0.352-1.596,0.863-3.107,2.496-3.107H1098.558z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087375974277829666890000003561300198155915398_",
    gradientUnits: "userSpaceOnUse",
    x1: -1261.8846,
    y1: 1658.7487,
    x2: -1416.1669,
    y2: 1776.7981,
    gradientTransform: "matrix(1 0 0 1 2420.5969 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087375974277829666890000003561300198155915398_)"
    },
    d: "M1099.726,1721.972 c0,0-10.296-39.603-28.051-28.499c-17.755,11.104,9.214,44.374,23.489,45.855L1099.726,1721.972z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031191175128579831120000008302702610932382627_",
    gradientUnits: "userSpaceOnUse",
    x1: -1684.828,
    y1: 1736.7418,
    x2: -1358.1681,
    y2: 2018.915,
    gradientTransform: "matrix(-1 0 0 1 -160.9626 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031191175128579831120000008302702610932382627_)"
    },
    d: "M1449.194,1830.791 c0,0-13.528-23.984-12.668-35.636c0.861-11.652-6.4-28.765,1.326-27.498c7.727,1.266,9.322,0.233,11.419,14.215 C1451.369,1795.854,1475.754,1856.926,1449.194,1830.791z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031886604909729991600000003470780146958593963_",
    gradientUnits: "userSpaceOnUse",
    x1: -1691.64,
    y1: 1763.0476,
    x2: -1373.6653,
    y2: 2037.7185,
    gradientTransform: "matrix(-1 0 0 1 -160.9626 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031886604909729991600000003470780146958593963_)"
    },
    d: "M1451.737,1792.658l-0.311,47.912 c-91.571,98.868-165.688,104.688-225.792,83.441c-18.17,29.606-40.358,69.424-50.435,101.866 c244.538,53.912,302.123-170.896,302.123-170.896c33.121-13.719,39.798-21.745,38.374-30.735L1451.737,1792.658z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004543454893419540930000008183559157971082422_",
    gradientUnits: "userSpaceOnUse",
    x1: -1696.921,
    y1: 1750.7412,
    x2: -1370.262,
    y2: 2032.9138,
    gradientTransform: "matrix(-1 0 0 1 -160.9626 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004543454893419540930000008183559157971082422_)"
    },
    d: "M1522.16,1745.126 c-7.816-3.174-23.11-32.331-26.039-22.739s1.237,22.739,0,26.817c-1.237,4.08-20.304,51.007-16.496,61.432 c2.747,7.523,17.886,6.411,20.196,18.718c0.767,4.084,4.032,7.014,7.819,7.017c3.786,0.002,7.053-2.924,7.825-7.008 C1515.774,1827.726,1529.976,1748.298,1522.16,1745.126z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049216174883487992070000006038930593893604769_",
    gradientUnits: "userSpaceOnUse",
    x1: 527.4989,
    y1: 1846.2122,
    x2: -61.1504,
    y2: 3081.0952,
    gradientTransform: "matrix(0.4597 -0.8881 0.8881 0.4597 -758.4859 793.5534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049216174883487992070000006038930593893604769_)"
    },
    d: "M1272.563,1645.338 c-61.749,122.128-12.801,271.19,109.328,332.938c99.265,50.188,216.321,27.245,289.827-48.681l424.329,214.541 c7.047,3.563,15.43,3.274,22.215-0.768l41.5-24.721c0.714-0.425,1.388-0.894,2.041-1.384c0.184-0.138,0.358-0.285,0.537-0.428 c0.483-0.385,0.948-0.786,1.393-1.204c0.152-0.143,0.303-0.284,0.45-0.43c0.551-0.545,1.076-1.112,1.565-1.705 c0.008-0.009,0.016-0.017,0.023-0.025c5.21-6.343,6.802-15.195,3.612-23.192l-33.725-84.535 c-2.083-5.222-6.001-9.502-11.018-12.04l-42.502-21.489l-11.247,22.246L2034.38,1976l11.247-22.246l-34.158-17.27 l-10.347,20.464l-44.375-22.436l10.347-20.465l-16.533-8.359l-5.326,10.534l-37.2-18.808l5.326-10.534l-28.933-14.629 l-11.247,22.245l-20.667-10.449l11.248-22.245l-17.912-9.056l-11.247,22.245l-35.822-18.111l11.247-22.246l-50.351-25.457l0,0 l-21.563-10.902c17.569-104.208-33.346-212.077-132.613-262.266C1483.372,1474.261,1334.31,1523.209,1272.563,1645.338z  M1417.135,1662.209c24.729,12.503,34.642,42.688,22.139,67.418c-12.504,24.731-42.689,34.641-67.418,22.138 c-24.729-12.503-34.643-42.688-22.139-67.417C1362.221,1659.617,1392.406,1649.706,1417.135,1662.209z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053509545005875131820000009229936530987410341_",
    gradientUnits: "userSpaceOnUse",
    x1: 4105.2314,
    y1: 0.9878,
    x2: 3760.2639,
    y2: 687.3659,
    gradientTransform: "matrix(0.9652 -0.2615 0.2615 0.9652 -1955.4407 2439.333)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053509545005875131820000009229936530987410341_)"
    },
    d: "M1616.51,1720.178l201.155,101.704 l-11.247,22.245l35.822,18.111l11.247-22.245l17.912,9.057l-11.248,22.245l20.667,10.449l11.247-22.245l28.933,14.629 l-5.326,10.534l37.2,18.808l5.326-10.534l16.533,8.359l-10.347,20.464l44.375,22.436l10.347-20.464l34.159,17.27l-11.248,22.246 l36.512,18.46l11.247-22.245l42.502,21.489c5.017,2.537,8.935,6.818,11.018,12.04l33.725,84.535 c4.202,10.535,0.123,22.563-9.622,28.368l-41.5,24.721c-6.785,4.042-15.167,4.332-22.215,0.768l-512.237-258.987 L1616.51,1720.178z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032642389341144126510000004504436243185949118_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.2225,
    y1: 2178.4968,
    x2: 590.6898,
    y2: 3373.429,
    gradientTransform: "matrix(0.4597 -0.8881 0.8881 0.4597 -758.4859 793.5534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032642389341144126510000004504436243185949118_)"
    },
    d: "M1389.529,1965.523 c122.129,61.749,271.19,12.8,332.938-109.328c61.748-122.128,12.801-271.19-109.328-332.938 c-122.129-61.749-271.19-12.8-332.938,109.328C1218.453,1754.713,1267.4,1903.774,1389.529,1965.523z M1379.495,1739.011 c-24.729-12.503-34.643-42.687-22.139-67.418c12.503-24.73,42.689-34.641,67.418-22.138 c24.729,12.503,34.642,42.688,22.139,67.418C1434.409,1741.604,1404.224,1751.515,1379.495,1739.011z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003822796961488324550000004766257061199891383_",
    gradientUnits: "userSpaceOnUse",
    x1: 1802.6949,
    y1: 1673.6989,
    x2: 2116.0364,
    y2: 877.0122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003822796961488324550000004766257061199891383_)"
    },
    d: "M1679.357,1916.842l424.329,214.541 c7.047,3.563,15.43,3.274,22.215-0.768l41.5-24.721c6.258-3.728,10.138-10.028,11.031-16.845 c-38.675-41.904-406.292-202.43-420.042-235.469c-4.891-11.752-5.73-29.551,8.926-57.154l-21.563-10.902 c17.569-104.208-33.346-212.078-132.613-262.267c-122.129-61.749-271.19-12.8-332.938,109.328 c-61.748,122.128-12.801,271.19,109.328,332.938C1488.794,2015.711,1605.85,1992.767,1679.357,1916.842z M1424.774,1649.456 c24.729,12.503,34.642,42.688,22.139,67.418c-12.504,24.73-42.689,34.641-67.418,22.138 c-24.729-12.503-34.643-42.687-22.139-67.418C1369.859,1646.864,1400.044,1636.953,1424.774,1649.456z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122679500371944411760000014136047836794511544_",
    gradientUnits: "userSpaceOnUse",
    x1: 1975.2948,
    y1: 826.0914,
    x2: 1921.96,
    y2: 929.4275
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122679500371944411760000014136047836794511544_)"
    },
    d: "M1411.472,1922.123 c98.161,49.63,217.966,10.288,267.596-87.871c49.629-98.159,10.289-217.965-87.872-267.595 c-98.161-49.63-217.966-10.288-267.595,87.871C1273.971,1752.687,1313.312,1872.492,1411.472,1922.123z M1379.495,1739.011 c-24.729-12.503-34.643-42.687-22.139-67.418c12.503-24.73,42.689-34.641,67.418-22.138 c24.729,12.503,34.642,42.688,22.139,67.418C1434.409,1741.604,1404.224,1751.515,1379.495,1739.011z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006697058447867369260000007312330356238950535_",
    gradientUnits: "userSpaceOnUse",
    x1: -820.4249,
    y1: 4045.7346,
    x2: -1214.6862,
    y2: 4730.7979,
    gradientTransform: "matrix(0.9478 -0.3187 0.3187 0.9478 817.2306 -2113.7644)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006697058447867369260000007312330356238950535_)"
    },
    d: "M1074.9,2059.561 c0,0,233.348,78.116,363.872-21.26c8.095-6.164,18.31-8.851,28.353-7.216l49.864,8.124c20.929,3.409,40.867-10.154,45.379-30.874 c2.573-11.819,3.813-24.746,1.191-35.85l-94.135-5.679l2.692-12.214c0,0-41.606,10.177-42.444,42.73 c0,0-97.595,63.931-275.603-35.298C1154.07,1962.024,1084.752,2016.271,1074.9,2059.561z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2877.242,889.663c-5.434-0.222-9.658-4.809-9.434-10.241 c0.432-10.556,0.414-21.286-0.057-31.896c-0.239-5.368,3.869-9.922,9.208-10.261c0.063-0.004,0.126-0.008,0.192-0.012 c5.432-0.241,10.03,3.968,10.271,9.402c0.495,11.167,0.516,22.465,0.059,33.576c-0.207,5.081-4.235,9.105-9.201,9.42 C2877.938,889.672,2877.591,889.679,2877.242,889.663z M2861.916,796.042c-1.911-10.442-4.288-20.899-7.066-31.093 c-1.429-5.242,1.663-10.657,6.909-12.088c5.271-1.417,10.659,1.666,12.088,6.913c2.923,10.724,5.426,21.733,7.439,32.718 c0.979,5.348-2.564,10.479-7.913,11.458c-0.388,0.071-0.777,0.118-1.16,0.143 C2867.302,804.405,2862.824,801.002,2861.916,796.042z M2837.789,716.055c-4.176-9.727-8.826-19.39-13.825-28.726 c-2.566-4.793-0.76-10.761,4.032-13.327c4.792-2.559,10.757-0.76,13.327,4.033c5.264,9.831,10.162,20.01,14.558,30.251 c2.145,4.996-0.167,10.785-5.162,12.933c-1.065,0.457-2.167,0.712-3.26,0.781 C2843.421,722.256,2839.476,719.986,2837.789,716.055z M2796.378,643.473c-6.252-8.559-12.95-16.943-19.904-24.926 c-3.571-4.101-3.143-10.321,0.956-13.891c4.103-3.567,10.319-3.137,13.891,0.956c7.322,8.406,14.371,17.235,20.955,26.239 c3.207,4.39,2.25,10.551-2.14,13.758c-1.571,1.148-3.368,1.763-5.176,1.878C2801.715,647.693,2798.439,646.29,2796.378,643.473 z M2739.83,581.925c-7.978-6.939-16.366-13.636-24.933-19.897c-4.389-3.212-5.344-9.372-2.136-13.76 c3.211-4.392,9.372-5.346,13.759-2.133c9.012,6.588,17.839,13.635,26.233,20.936c4.103,3.566,4.536,9.786,0.967,13.889 c-1.798,2.068-4.269,3.204-6.804,3.365C2744.42,584.482,2741.865,583.696,2739.83,581.925z M2671.073,534.424 c-9.328-5.011-18.987-9.681-28.71-13.885c-4.99-2.157-7.289-7.954-5.132-12.942c2.157-4.992,7.95-7.291,12.944-5.134 c10.233,4.422,20.4,9.341,30.217,14.614c4.789,2.575,6.586,8.542,4.014,13.333c-1.671,3.112-4.776,4.958-8.059,5.167 C2674.575,535.69,2672.752,535.328,2671.073,534.424z M2305.496,529.841c-2.559-4.797-0.745-10.762,4.054-13.321 c9.829-5.24,20.022-10.123,30.291-14.509c5.001-2.136,10.787,0.186,12.921,5.188c2.136,4.997-0.187,10.783-5.186,12.919 c-9.751,4.164-19.428,8.802-28.761,13.779c-1.281,0.683-2.642,1.054-4.003,1.14 C2311.078,535.274,2307.371,533.359,2305.496,529.841z M2593.544,503.365c-10.203-2.809-20.652-5.21-31.06-7.131 c-5.348-0.99-8.882-6.126-7.894-11.472c0.988-5.35,6.122-8.855,11.472-7.892c10.959,2.025,21.963,4.552,32.708,7.512 c5.242,1.444,8.322,6.863,6.878,12.107c-1.145,4.158-4.792,6.956-8.868,7.214 C2595.72,503.77,2594.629,503.662,2593.544,503.365z M2384.441,496.213c-1.42-5.247,1.686-10.654,6.935-12.074 c10.752-2.906,21.772-5.386,32.751-7.377c5.351-0.995,10.472,2.584,11.444,7.932c0.969,5.349-2.582,10.472-7.933,11.444 c-10.435,1.892-20.908,4.248-31.125,7.012c-0.652,0.176-1.306,0.279-1.955,0.321 C2389.983,503.761,2385.682,500.809,2384.441,496.213z M2511.034,490.413c-10.568-0.455-21.295-0.46-31.885-0.011 c-5.434,0.233-10.023-3.984-10.255-9.419c-0.227-5.361,3.878-9.903,9.209-10.242c0.069-0.004,0.14-0.009,0.209-0.009 c11.149-0.476,22.442-0.473,33.565,0.004c5.433,0.237,9.648,4.829,9.414,10.262c-0.217,5.073-4.242,9.086-9.201,9.401 C2511.744,490.422,2511.39,490.425,2511.034,490.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2257.003,572.953c1.935-0.123,3.854-0.815,5.488-2.113c3.975-3.158,8.083-6.282,12.208-9.295 c4.392-3.204,5.355-9.365,2.15-13.755c-3.204-4.394-9.367-5.363-13.757-2.148c-4.34,3.166-8.659,6.453-12.844,9.775 c-4.258,3.38-4.97,9.576-1.59,13.831C2250.742,571.875,2253.894,573.151,2257.003,572.953z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2113.47,836.577c4.742-0.301,8.698-4.005,9.167-8.886c0.483-5.052,1.08-10.18,1.776-15.238 c0.741-5.388-3.025-10.355-8.411-11.096c-5.41-0.743-10.355,3.027-11.096,8.412c-0.731,5.325-1.362,10.726-1.872,16.045 c-0.518,5.413,3.45,10.22,8.863,10.74C2112.427,836.604,2112.954,836.61,2113.47,836.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2499.683,1256.888c-5.437,0.079-9.909-4.265-9.987-9.706c-0.077-5.436,4.262-9.896,9.704-9.984 c10.351-0.148,20.856-0.742,31.344-1.762c5.384-0.542,10.226,3.436,10.753,8.848s-3.434,10.225-8.845,10.754 c-4.544,0.442-9.078,0.807-13.599,1.094C2512.603,1256.542,2506.086,1256.798,2499.683,1256.888z M2573.729,1238.92 c-1.253-5.288,2.019-10.594,7.309-11.847c10.157-2.41,20.323-5.271,30.213-8.511c5.156-1.707,10.729,1.122,12.423,6.29 c1.692,5.165-1.125,10.727-6.291,12.419c-10.413,3.413-21.114,6.427-31.803,8.959c-0.554,0.131-1.11,0.213-1.658,0.248 C2579.222,1246.776,2574.853,1243.658,2573.729,1238.92z M2446.111,1253.984c-10.871-1.341-21.835-3.165-32.586-5.427 c-5.321-1.119-8.728-6.34-7.609-11.663c1.119-5.32,6.339-8.719,11.662-7.608c10.21,2.15,20.618,3.882,30.942,5.154 c5.397,0.667,9.233,5.58,8.568,10.979c-0.589,4.773-4.504,8.324-9.137,8.618 C2447.348,1254.075,2446.732,1254.06,2446.111,1253.984z M2653.953,1212.572c-2.385-4.885-0.359-10.783,4.528-13.166 c9.367-4.572,18.649-9.6,27.59-14.942c4.67-2.793,10.711-1.269,13.501,3.401c2.789,4.667,1.267,10.71-3.399,13.499 c-9.416,5.627-19.191,10.922-29.054,15.736c-1.192,0.58-2.443,0.903-3.691,0.982 C2659.565,1218.328,2655.756,1216.265,2653.953,1212.572z M2361.945,1233.943c-10.304-3.697-20.593-7.888-30.584-12.456 c-4.945-2.26-7.121-8.099-4.862-13.044c2.26-4.949,8.103-7.124,13.048-4.863c9.491,4.338,19.264,8.319,29.05,11.828 c5.119,1.837,7.779,7.476,5.942,12.594c-1.369,3.814-4.847,6.261-8.647,6.503 C2364.589,1234.588,2363.248,1234.411,2361.945,1233.943z M2284.214,1195.929c-9.269-5.874-18.397-12.208-27.133-18.825 c-4.334-3.286-5.186-9.459-1.903-13.795c3.289-4.34,9.463-5.19,13.793-1.901c8.301,6.286,16.976,12.306,25.783,17.89 c4.593,2.911,5.956,8.994,3.045,13.587c-1.755,2.766-4.662,4.361-7.699,4.554 C2288.096,1197.567,2286.037,1197.085,2284.214,1195.929z M2216.611,1141.876c-7.774-7.757-15.306-15.93-22.387-24.286 c-3.516-4.151-3.001-10.36,1.146-13.876c4.154-3.52,10.363-3,13.876,1.146c6.728,7.943,13.885,15.704,21.274,23.077 c3.849,3.841,3.855,10.075,0.015,13.922c-1.764,1.769-4.031,2.726-6.342,2.872 C2221.472,1144.905,2218.693,1143.953,2216.611,1141.876z M2162.411,1074.365c-5.889-9.268-11.45-18.896-16.527-28.616 c-2.518-4.819-0.653-10.768,4.168-13.286c4.811-2.514,10.766-0.649,13.284,4.17c4.821,9.228,10.1,18.369,15.696,27.174 c2.916,4.589,1.56,10.672-3.03,13.587c-1.45,0.921-3.047,1.415-4.648,1.517 C2167.887,1079.131,2164.408,1077.506,2162.411,1074.365z M2124.35,996.553c-3.693-10.313-6.992-20.921-9.809-31.531 c-1.395-5.256,1.735-10.65,6.991-12.043c5.24-1.389,10.646,1.733,12.041,6.989c2.675,10.081,5.809,20.155,9.315,29.952 c1.833,5.117-0.832,10.754-5.95,12.586c-0.891,0.319-1.799,0.504-2.698,0.561 C2129.972,1003.337,2125.864,1000.781,2124.35,996.553z M2104.325,912.371c-1.002-8.01-1.769-16.15-2.279-24.191 c-0.185-2.913-0.336-5.816-0.457-8.719c-0.226-5.43,3.922-10.122,9.427-10.244c5.432-0.229,10.02,3.992,10.248,9.427 c0.115,2.756,0.258,5.521,0.434,8.288c0.485,7.646,1.213,15.38,2.165,22.996c0.675,5.394-3.153,10.315-8.547,10.989 c-0.203,0.024-0.406,0.045-0.607,0.058C2109.555,921.303,2104.973,917.563,2104.325,912.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2734.909,1172.724c1.954-0.124,3.888-0.828,5.529-2.143c4.158-3.335,8.324-6.821,12.382-10.362 c4.099-3.574,4.523-9.794,0.949-13.891c-3.576-4.097-9.79-4.527-13.891-0.949c-3.856,3.363-7.813,6.673-11.76,9.841 c-4.241,3.398-4.923,9.596-1.521,13.838C2728.684,1171.659,2731.82,1172.92,2734.909,1172.724z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2753.508,1004.966c1.142-1.598,1.146-3.742,0.009-5.343l-32.435-45.657 c9.968-24.181,16.15-50.125,17.919-76.983l49.214-26.656c1.726-0.935,2.668-2.863,2.347-4.799l-10.99-66.272 c-0.32-1.937-1.836-3.457-3.771-3.784l-55.185-9.343c-10.343-24.849-24.57-47.41-41.81-67.078l15.961-53.682 c0.559-1.882-0.137-3.911-1.733-5.053l-54.633-39.091c-1.596-1.142-3.743-1.146-5.343-0.009l-45.656,32.435 c-24.181-9.968-50.125-16.152-76.983-17.92l-26.656-49.214c-0.935-1.727-2.862-2.67-4.799-2.348l-66.274,10.99 c-1.937,0.322-3.456,1.836-3.784,3.771l-9.343,55.185c-24.849,10.343-47.41,24.57-67.078,41.81l-53.683-15.962 c-1.882-0.559-3.911,0.136-5.053,1.733l-39.091,54.633c-1.142,1.596-1.145,3.742-0.01,5.342l32.436,45.658 c-9.969,24.18-16.151,50.124-17.919,76.983l-49.214,26.656c-1.727,0.934-2.67,2.862-2.348,4.798l10.99,66.274 c0.322,1.937,1.836,3.456,3.771,3.784l55.185,9.344c10.343,24.849,24.571,47.409,41.81,67.078l-15.961,53.682 c-0.56,1.881,0.136,3.911,1.733,5.054l54.633,39.091c1.596,1.142,3.742,1.146,5.342,0.009l45.657-32.436 c24.181,9.968,50.125,16.151,76.983,17.92l26.656,49.214c0.935,1.725,2.862,2.668,4.799,2.348l66.273-10.991 c1.936-0.321,3.457-1.835,3.784-3.771l9.343-55.184c24.849-10.344,47.409-24.571,67.078-41.81l53.683,15.961 c1.882,0.56,3.911-0.137,5.053-1.733L2753.508,1004.966z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2488.489,927.941c-37.105-3.086-64.784-35.78-61.699-72.889 c1.492-17.975,9.898-34.293,23.665-45.945c13.763-11.652,31.244-17.251,49.222-15.752c37.106,3.086,64.784,35.78,61.7,72.889 c-2.807,33.758-30.121,59.712-62.971,61.797C2495.149,928.247,2491.834,928.218,2488.489,927.941z M2460.633,821.131 c-10.556,8.936-16.999,21.445-18.145,35.229c-2.364,28.447,18.858,53.52,47.306,55.884 c28.457,2.375,53.52-18.858,55.885-47.308c2.364-28.447-18.858-53.52-47.307-55.884c-2.58-0.214-5.142-0.236-7.679-0.075 C2479.676,809.675,2469.212,813.87,2460.633,821.131z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2503.205,1025.462c5.642-0.358,11.299-1.002,16.952-1.939l0,0 c1.779-0.294,3.554-0.619,5.324-0.97c8.724-1.737,17.296-4.165,25.585-7.246c0.113-0.042,0.226-0.084,0.339-0.125 c0.32-0.12,0.64-0.241,0.959-0.365c0.623-0.236,1.243-0.48,1.862-0.723c1.628-0.643,2.588-2.249,2.484-3.907 c-0.026-0.403-0.115-0.81-0.271-1.204c-0.799-2.023-3.089-3.006-5.11-2.211c-10.407,4.117-21.328,7.138-32.459,8.981 c-55.289,9.178-108.741-11.661-143.674-50.553c-19.433-21.63-33.134-48.849-38.232-79.6 c-0.896-5.392-1.512-10.79-1.851-16.172c-2.295-36.216,7.852-71.824,29.254-101.733 c24.582-34.358,61.074-57.087,102.749-63.998c86.073-14.265,167.639,44.122,181.905,130.153 c0.88,5.305,1.488,10.634,1.824,15.965c1.463,23.102-2.146,46.268-10.649,67.821c-0.219,0.557-0.304,1.133-0.267,1.693 c0.094,1.474,1.018,2.837,2.485,3.414c2.027,0.792,4.312-0.189,5.109-2.22c8.926-22.628,12.717-46.95,11.182-71.203 c-0.353-5.596-0.991-11.189-1.913-16.757c-14.978-90.325-100.672-151.611-190.964-136.639 c-43.753,7.255-82.06,31.116-107.867,67.186c-22.469,31.399-33.12,68.781-30.712,106.801 c0.359,5.65,1.006,11.316,1.942,16.975c7.257,43.755,31.117,82.064,67.185,107.871 C2427.785,1017.228,2465.177,1027.875,2503.205,1025.462z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3230.018,1127.302c2.625-0.167,4.935-2.033,5.543-4.731c1.138-5.035,2.139-10.174,2.973-15.273 c0.542-3.313-1.703-6.437-5.019-6.983c-3.317-0.557-6.44,1.706-6.983,5.019c-0.795,4.859-1.749,9.756-2.833,14.562 c-0.741,3.272,1.316,6.527,4.591,7.271C3228.872,1127.297,3229.452,1127.338,3230.018,1127.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3235.467,1080.931c-3.355-0.132-5.971-2.953-5.842-6.312c0.322-8.47,0.215-17.055-0.322-25.512 c-0.113-1.784-0.248-3.573-0.4-5.366c-0.281-3.344,2.201-6.286,5.548-6.57c3.175-0.142,6.286,2.202,6.573,5.551 c0.157,1.876,0.298,3.748,0.416,5.615c0.563,8.866,0.676,17.867,0.335,26.749c-0.118,3.143-2.608,5.64-5.684,5.835 C3235.887,1080.934,3235.679,1080.935,3235.467,1080.931z M3224.432,1013.185c-2.105-10.059-4.851-20.078-8.165-29.775 c-1.085-3.18,0.608-6.631,3.788-7.72c3.163-1.076,6.635,0.608,7.72,3.788c3.474,10.163,6.354,20.667,8.56,31.214 c0.688,3.288-1.42,6.51-4.708,7.201c-0.287,0.06-0.58,0.096-0.867,0.114C3227.79,1018.196,3225.059,1016.18,3224.432,1013.185z  M3204.477,954.865c-4.498-9.223-9.624-18.258-15.236-26.863c-1.833-2.811-1.04-6.58,1.772-8.413 c2.823-1.839,6.58-1.048,8.416,1.769c5.886,9.021,11.26,18.504,15.98,28.172c1.471,3.018,0.22,6.662-2.798,8.133 c-0.737,0.356-1.51,0.554-2.28,0.603C3207.945,958.418,3205.591,957.145,3204.477,954.865z M3170.802,903.23 c-6.633-7.85-13.816-15.361-21.341-22.31c-2.468-2.283-2.62-6.129-0.34-8.594c2.274-2.459,6.123-2.62,8.592-0.343 c7.895,7.294,15.421,15.164,22.38,23.398c2.168,2.564,1.843,6.404-0.721,8.573c-1.037,0.869-2.277,1.34-3.534,1.42 C3173.98,905.491,3172.095,904.76,3170.802,903.23z M3125.541,861.38c-8.339-5.998-17.125-11.534-26.119-16.461 c-2.943-1.61-4.023-5.308-2.41-8.254c1.613-2.947,5.308-4.032,8.255-2.41c9.426,5.161,18.636,10.967,27.378,17.25 c2.724,1.963,3.346,5.762,1.387,8.486c-1.107,1.54-2.802,2.409-4.556,2.521C3128.121,862.597,3126.729,862.233,3125.541,861.38 z M3071.494,831.786c-9.538-3.786-19.399-7.01-29.318-9.581c-3.249-0.841-5.203-4.162-4.359-7.411 c0.844-3.249,4.151-5.196,7.414-4.362c10.4,2.696,20.748,6.08,30.752,10.05c3.119,1.242,4.647,4.775,3.408,7.894 c-0.898,2.258-2.998,3.683-5.27,3.828C3073.252,832.258,3072.358,832.13,3071.494,831.786z M3011.875,816.315 c-10.143-1.325-20.505-2.031-30.8-2.091c-3.358-0.025-6.063-2.763-6.041-6.12c0.019-3.357,2.754-6.012,6.119-6.047 c10.792,0.071,21.657,0.809,32.295,2.199c3.33,0.437,5.678,3.489,5.243,6.819c-0.382,2.928-2.794,5.098-5.638,5.279 C3012.667,816.378,3012.273,816.368,3011.875,816.315z M2912.496,816.935c-0.796-3.263,1.203-6.55,4.467-7.347 c9.032-2.204,18.341-3.949,27.64-5.188c1.413-0.196,2.821-0.369,4.232-0.536c3.307-0.484,6.357,2,6.739,5.344 c0.387,3.337-2.004,6.351-5.341,6.741c-1.324,0.15-2.649,0.317-3.996,0.504c-8.901,1.183-17.781,2.848-26.394,4.948 c-0.355,0.088-0.711,0.14-1.061,0.162C2915.893,821.747,2913.204,819.841,2912.496,816.935z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2992.296,1327.047c-10.584,0.535-21.293,0.423-31.831-0.318 c-3.347-0.24-5.873-3.144-5.636-6.497c0.236-3.354,3.166-5.842,6.497-5.637c10.048,0.712,20.262,0.814,30.36,0.304 c3.354-0.172,6.21,2.414,6.379,5.766c0.167,3.327-2.373,6.166-5.685,6.377 C2992.352,1327.044,2992.322,1327.046,2992.296,1327.047z M3016.93,1318.569c-0.569-3.308,1.652-6.454,4.961-7.021 c9.956-1.715,19.908-4.048,29.581-6.941c3.201-0.947,6.606,0.866,7.566,4.09c0.963,3.218-0.866,6.6-4.083,7.566 c-10.137,3.03-20.568,5.477-31.001,7.269c-0.221,0.038-0.436,0.064-0.656,0.078 C3020.24,1323.804,3017.463,1321.665,3016.93,1318.569z M2928.885,1322.539c-10.406-2.041-20.775-4.733-30.819-8.005 c-3.193-1.041-4.94-4.476-3.899-7.666c1.038-3.196,4.459-4.93,7.663-3.902c9.582,3.123,19.47,5.691,29.398,7.643 c3.296,0.647,5.442,3.844,4.796,7.133c-0.544,2.771-2.889,4.729-5.58,4.9 C2929.935,1322.675,2929.413,1322.643,2928.885,1322.539z M3076.855,1302.151c-1.349-3.074,0.053-6.662,3.127-8.011 c9.251-4.057,18.342-8.721,27.023-13.872c2.888-1.707,6.619-0.754,8.331,2.125c1.713,2.89,0.762,6.622-2.127,8.334 c-9.103,5.404-18.641,10.299-28.344,14.551c-0.672,0.292-1.366,0.455-2.056,0.499 C3080.333,1305.934,3077.909,1304.553,3076.855,1302.151z M2868.466,1302.847c-9.588-4.473-19.001-9.582-27.984-15.182 c-2.85-1.777-3.719-5.53-1.942-8.38c1.777-2.85,5.526-3.725,8.38-1.943c8.566,5.347,17.544,10.216,26.69,14.479 c3.042,1.42,4.36,5.037,2.938,8.084c-0.971,2.085-2.982,3.361-5.13,3.497 C2870.436,1303.465,2869.422,1303.292,2868.466,1302.847z M2814.526,1269.23c-8.253-6.653-16.176-13.867-23.547-21.438 c-2.342-2.404-2.292-6.251,0.115-8.594c2.401-2.342,6.254-2.295,8.6,0.115c7.03,7.218,14.59,14.098,22.466,20.448 c2.615,2.107,3.025,5.936,0.917,8.551c-1.114,1.38-2.708,2.148-4.353,2.252 C2817.261,1270.657,2815.758,1270.222,2814.526,1269.23z M2770.184,1223.662c-6.427-8.44-12.389-17.35-17.722-26.473 c-1.695-2.903-0.718-6.625,2.182-8.32c2.897-1.696,6.623-0.712,8.317,2.179c5.084,8.704,10.77,17.197,16.9,25.24 c2.035,2.673,1.519,6.49-1.155,8.523c-0.99,0.759-2.137,1.159-3.292,1.232 C2773.452,1226.168,2771.466,1225.342,2770.184,1223.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3136.47,1273.923c1.171-0.074,2.331-0.487,3.33-1.259c4.118-3.183,8.158-6.504,12.015-9.866 c2.529-2.208,2.793-6.051,0.586-8.582c-2.21-2.519-6.047-2.788-8.582-0.586c-3.676,3.209-7.533,6.375-11.461,9.415 c-2.657,2.055-3.143,5.876-1.089,8.53C3132.553,1273.232,3134.523,1274.047,3136.47,1273.923z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3152.607,1159.287c0.764-1.069,0.766-2.504,0.006-3.575l-21.704-30.552 c6.67-16.181,10.807-33.541,11.99-51.513l32.932-17.837c1.155-0.626,1.786-1.915,1.571-3.212l-7.355-44.346 c-0.214-1.296-1.229-2.314-2.522-2.532l-36.927-6.252c-6.921-16.628-16.441-31.725-27.977-44.886l10.68-35.922 c0.375-1.259-0.092-2.617-1.16-3.382l-36.558-26.158c-1.068-0.764-2.504-0.767-3.575-0.006l-30.551,21.704 c-16.181-6.67-33.542-10.808-51.514-11.991l-17.837-32.932c-0.626-1.155-1.915-1.786-3.211-1.571l-44.347,7.354 c-1.296,0.215-2.312,1.229-2.532,2.524l-6.252,36.927c-16.628,6.921-31.725,16.441-44.885,27.978l-35.922-10.681 c-1.259-0.374-2.617,0.091-3.381,1.16l-26.158,36.559c-0.764,1.068-0.766,2.503-0.006,3.574l21.705,30.553 c-6.67,16.18-10.808,33.541-11.991,51.513l-32.932,17.837c-1.155,0.625-1.786,1.914-1.571,3.211l7.354,44.347 c0.215,1.296,1.228,2.312,2.524,2.532l36.927,6.252c6.921,16.628,16.442,31.724,27.978,44.886l-10.68,35.922 c-0.375,1.259,0.091,2.617,1.16,3.382l36.558,26.158c1.069,0.764,2.504,0.766,3.575,0.006l30.552-21.705 c16.181,6.67,33.541,10.807,51.514,11.991l17.837,32.932c0.626,1.155,1.915,1.786,3.211,1.571l44.347-7.355 c1.296-0.215,2.313-1.228,2.532-2.524l6.252-36.926c16.628-6.921,31.724-16.442,44.885-27.978l35.922,10.681 c1.259,0.375,2.617-0.092,3.381-1.16L3152.607,1159.287z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2975.205,1108.554c-12.248-1.014-23.364-6.74-31.301-16.12 c-7.938-9.374-11.749-21.282-10.73-33.528c2.1-25.273,24.338-44.089,49.651-42.03c25.276,2.108,44.127,24.38,42.024,49.647 c-1.017,12.245-6.74,23.36-16.117,31.298c-7.623,6.452-16.919,10.178-26.709,10.799 C2979.773,1108.764,2977.493,1108.742,2975.205,1108.554z M2945.293,1059.91c-0.749,9.009,2.053,17.768,7.894,24.669 c5.837,6.895,14.016,11.106,23.021,11.856l0,0c9.008,0.737,17.765-2.056,24.666-7.897 c6.897-5.834,11.106-14.016,11.855-23.019c1.545-18.592-12.321-34.974-30.912-36.524c-1.678-0.137-3.336-0.151-4.969-0.048 C2960.388,1029.992,2946.698,1043,2945.293,1059.91z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2985.452,1176.427c3.84-0.244,7.698-0.685,11.573-1.324 c7.693-1.274,15.265-3.331,22.522-6.124c0.325-0.128,0.65-0.256,0.976-0.384c2.514-0.992,3.995-3.473,3.836-6.033 c-0.04-0.622-0.177-1.25-0.418-1.859c-1.234-3.123-4.769-4.636-7.89-3.415c-6.751,2.672-13.821,4.626-21.01,5.814l-0.003,0 c-0.394,0.066-0.792,0.127-1.184,0.188c-17.042,2.659-34.102,0.969-49.923-4.691c-8.588-3.073-16.813-7.323-24.47-12.698 c-0.063-0.044-0.124-0.087-0.187-0.131c-0.19-0.137-0.38-0.268-0.567-0.405c-22.24-15.916-36.956-39.538-41.429-66.519 c-0.582-3.492-0.979-6.983-1.2-10.468c-1.485-23.445,5.085-46.497,18.939-65.864c15.916-22.241,39.539-36.95,66.517-41.424 c26.963-4.461,54.088,1.827,76.332,17.737c22.24,15.915,36.956,39.538,41.429,66.519c0.572,3.432,0.963,6.883,1.182,10.332 c0.946,14.959-1.389,29.953-6.894,43.905c-0.338,0.86-0.469,1.749-0.412,2.615c0.145,2.276,1.572,4.381,3.836,5.273 c3.127,1.224,6.655-0.297,7.89-3.428c6.158-15.612,8.773-32.391,7.718-49.121c-0.245-3.864-0.683-7.722-1.32-11.561 c-5.007-30.189-21.469-56.617-46.355-74.423c-24.883-17.801-55.197-24.874-85.394-19.845 c-30.186,5.004-56.614,21.462-74.418,46.352c-15.503,21.662-22.851,47.452-21.189,73.683 c0.247,3.894,0.691,7.805,1.338,11.708C2874.971,1139.276,2927.557,1180.102,2985.452,1176.427z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.10a33cdf855226e56aebe3c2f4f2c62d.svg";
export { ForwardRef as ReactComponent };